import React from 'react';
import { MobileStepper, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    width: '100%',
    bottom: 0
  }
}));

const StepButtonsMobile = ({ activeStep, setActiveStep, nextEnabled, advanceText }) => {
  const classes = useStyles({})
;
  return (
    <MobileStepper
      variant="dots"
      steps={2}
      className={classes.root}
      activeStep={activeStep}
      nextButton={
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => setActiveStep(activeStep + 1)}
          disabled={!nextEnabled}
        >
          {advanceText}
          <KeyboardArrowRight />
        </Button>
      }
      backButton={
        <Button size="small" onClick={() => setActiveStep(activeStep - 1)} disabled={activeStep === 0}>
          <KeyboardArrowLeft />
          Back
        </Button>
      }
    />
  );
};

export default StepButtonsMobile;
